import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import get from 'lodash.get';
import keyBy from 'lodash.keyby';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectSprayWorksheetCalibrations = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (sprayWorksheetState, index) =>
        get(sprayWorksheetState, ['pages', index, 'calibrations'], [])
);

const makeSelectSprayWorksheetCalibrations =
    (): typeof selectSprayWorksheetCalibrations =>
        selectSprayWorksheetCalibrations;

const selectSprayWorksheetCalibrationsKeyedById = createDeepEqualSelector(
    selectSprayWorksheetCalibrations,
    (calibrationsState) => keyBy(calibrationsState, 'id')
);

export {
    selectPageIndex,
    selectSprayWorksheetCalibrationsKeyedById,
    makeSelectSprayWorksheetCalibrations
};
